import { gql } from 'graphql-tag'
import { settingsFragment } from '../../admin/station/stationSettings/settingsQueries'

export const dailySalesIncentivesReportFragment = gql`
  fragment dailySalesIncentivesReportFragment on DailySalesIncentiveReport {
    date
    chainTarget
    euroTarget
    euroActual
    kassuEuroActual
    mojovaEuroActual
    expressCheckoutEuroActual
  }
`

const incentiveSalesProductFragment = gql`
  fragment IncentiveSalesProductFragment on SalesIncentiveProduct {
    name
    price
    id
  }
`

export const incentiveSalesProductsQuery = gql`
  query IncentiveSalesProductsQuery($stationId: ID!, $fromDate: String!, $toDate: String!) {
    incentiveProductsSold(stationId: $stationId, fromDate: $fromDate, toDate: $toDate) {
      ...IncentiveSalesProductFragment
    }
  }
  ${incentiveSalesProductFragment}
`

export const fetchSalesIncentivesReport = gql`
  query fetchDailySalesIncentives($stationId: ID!, $userId: ID, $productId: ID, $fromDate: String, $toDate: String) {
    reportDailySalesIncentives(
      stationId: $stationId
      userId: $userId
      productId: $productId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      ...dailySalesIncentivesReportFragment
    }
    stationSettings(stationId: $stationId) {
      ...SettingsFragment
    }
  }
  ${dailySalesIncentivesReportFragment}
  ${settingsFragment}
`

export const fetchEmployeesList = gql`
  query FetchEmployeeList($stationId: ID!) {
    employees(stationId: $stationId) {
      edges {
        node {
          id
          user {
            id
            name
          }
        }
      }
    }
  }
`
